export const pageTypeAction = (pageType) => {
	return {
		type: "PAGE_TYPE",
		payload: pageType
	}
}